var _path, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00025 20.001C6.27525 20.001 6.55025 19.888 6.74725 19.665L14.7472 10.665C15.0843 10.286 15.0843 9.716 14.7472 9.337L6.74725 0.337C6.38125 -0.077 5.74925 -0.115 5.33625 0.254C4.92325 0.62 4.88625 1.253 5.25325 1.665L12.6623 10.001L5.25325 18.337C4.88625 18.749 4.92325 19.382 5.33625 19.748C5.52625 19.918 5.76425 20.001 6.00025 20.001Z",
    fill: "#637381"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 10,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00025 20.001C6.27525 20.001 6.55025 19.888 6.74725 19.665L14.7472 10.665C15.0843 10.286 15.0843 9.716 14.7472 9.337L6.74725 0.337C6.38125 -0.077 5.74925 -0.115 5.33625 0.254C4.92325 0.62 4.88625 1.253 5.25325 1.665L12.6623 10.001L5.25325 18.337C4.88625 18.749 4.92325 19.382 5.33625 19.748C5.52625 19.918 5.76425 20.001 6.00025 20.001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/right_icon.7fc9fad7.svg";
export { ForwardRef as ReactComponent };